var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { AnimatePresence, m } from 'framer-motion';
import { useFlyoutVariants } from '../config';
import styled from 'styled-components';
import FocusLock from 'react-focus-lock';
var InvertedDark = styled(m.div).attrs({
    className: 'encore-inverted-dark-set'
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: var(--background-base);\n  &:focus-visible,\n  &:focus,\n  &:active {\n    outline: none;\n  }\n"], ["\n  background-color: var(--background-base);\n  &:focus-visible,\n  &:focus,\n  &:active {\n    outline: none;\n  }\n"])));
export var FlyoutMenuContainer = function (_a) {
    var children = _a.children, contentKey = _a.contentKey, onClose = _a.onClose;
    var variants = useFlyoutVariants({
        initial: {},
        exit: {},
        animate: {}
    });
    var opacityVariant = useFlyoutVariants({
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        }
    });
    return (React.createElement(FocusLock, { returnFocus: true, autoFocus: true },
        React.createElement(InvertedDark, __assign({ key: "flyoutcontent", layout: true }, variants, { style: { overflow: 'hidden' }, role: "button", tabIndex: 0, onKeyDown: function (e) {
                if (e.key === 'Escape' && onClose) {
                    e.stopPropagation();
                    e.preventDefault();
                    onClose();
                }
            } }),
            React.createElement(AnimatePresence, { mode: "popLayout" },
                React.createElement(m.div, __assign({ key: contentKey + new Date(), layout: true, layoutRoot: true }, opacityVariant, { "data-testid": contentKey }), children)))));
};
var templateObject_1;
